import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

export default class ButtonBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      membersHidden: true,
    };
  }

  onClick = () => {
    this.setState( { membersHidden : !this.state.membersHidden });
  }

  render() {
    const { membersHidden } = this.state;
    return (
      <div className={cx("button-box", this.props.classname, { membersHidden })}>
        <div className="title" onClick={this.props.closable ? this.onClick : ""}>
          <h3>{this.props.title}</h3>
        </div>
        <div className="buttons">
          {this.props.buttons}
        </div>
      </div>
    );
  }
}

ButtonBox.propTypes = {
  buttons: PropTypes.array,
}



// WEBPACK FOOTER //
// ./src/ButtonBox.js